import classes from './UserResponse.module.css'


function UserResponse(params) {
    return (
        <div className={classes.UserResponseContainer}>
            <div className={classes.UserResponse}>
                {params.text}
            </div>
        </div>
    );
}

export default UserResponse;